<template>
  <div class="header">
    <slot></slot>
  </div>
</template>


<script>
export default {
  name: 'YHeader'
}
</script>

<style lang='scss' scoped>

</style>